  document.addEventListener('DOMContentLoaded', function() {
  const productForm = document.querySelector('form[action="/cart/add"]');
  const productPrice = document.querySelector('#price-value');

  if (productForm && productPrice) {
    productForm.addEventListener('change', function() {
      const selectedVariant = JSON.parse(productForm.querySelector('option:checked').dataset.variant);
      if (selectedVariant) {
        productPrice.textContent = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: selectedVariant.price.currency
        }).format(selectedVariant.price.amount);
      }
    });
  }
});
function changeModalImage(el){
  document.getElementById("modalMainImage").src = el.src.replace('120','1400');
}